import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faCloudDownloadAlt } from "@fortawesome/free-solid-svg-icons";

import TableWinnerItems from "./TableWinnerItems";

import * as api from "../util/api";

import "./Table.scss";

const PlayerTable = ({ deleted, handleExport, handleOpenDeleteAllAttendeesModal, handleOpenDeleteAttendeeModal, handleTableSort, attendeeList, tableSort }) => {

  const clsSort = Object.keys(tableSort).reduce((obj, key) => {
    obj[key] = tableSort[key] ? `is-${tableSort[key]}` : "";
    return obj;
  }, {});

  const tableInfoContainer = (
    <div className="table-info-container">
      <div className="form-row">
        <div className="col-12 d-flex align-items-center justify-content-between">
          <div className="heading">{attendeeList.length >= api.DEFAULT_LIMIT ? `${api.DEFAULT_LIMIT - 1}+` : attendeeList.length} participant{attendeeList.length === 1 ? "" : "s"}</div>
          <div className="table-btns-container d-flex align-items-center">
            {
              attendeeList.length > 0
              && (
                <div
                  className="table-download-btn btn btn-sm btn-outline-primary d-flex align-items-center"
                  onClick={handleExport}
                >
                  <FontAwesomeIcon
                    className="table-download-btn-icon"
                    icon={faCloudDownloadAlt}
                  />
                  <div className="table-download-label">Export data</div>
                </div>
              )
            }
            {
              !deleted
              && attendeeList.length > 0
              && (
                <button
                  className="table-delete-all-btn btn btn-sm btn-outline-danger d-flex"
                  onClick={handleOpenDeleteAllAttendeesModal}
                >
                  Delete all attendees
                </button>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="table-section">
      {tableInfoContainer}
      <div className="table-container">
        <table className="table" id="js-table">
          <thead>
            <tr className="table-row table-row-heading d-none d-md-table-row">
              <th className="table-heading" scope="col">
                &nbsp;
              </th>
              <th className="table-heading" scope="col">
                <div className="d-flex align-items-center justify-content-left" onClick={() => handleTableSort("name")}>
                  Name
                  <div className="table-sort-btn">
                    <FontAwesomeIcon
                      className={`table-sort-btn-icon ${clsSort.name}`}
                      icon={faArrowUp}
                    />
                  </div>
                </div>
              </th>
              <th className="table-heading" scope="col">
                <div className="d-flex align-items-center justify-content-left" onClick={() => handleTableSort("company")}>
                  Company
                  <div className="table-sort-btn">
                    <FontAwesomeIcon
                      className={`table-sort-btn-icon ${clsSort.company}`}
                      icon={faArrowUp}
                    />
                  </div>
                </div>
              </th>
              <th className="table-heading" scope="col">
                <div className="d-flex align-items-center justify-content-left" onClick={() => handleTableSort("email")}>
                  Email
                  <div className="table-sort-btn">
                    <FontAwesomeIcon
                      className={`table-sort-btn-icon ${clsSort.email}`}
                      icon={faArrowUp}
                    />
                  </div>
                </div>
              </th>
              <th className="table-heading" scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <TableWinnerItems
              deleted={deleted}
              handleDelete={handleOpenDeleteAttendeeModal}
              list={attendeeList}
              tableSort={tableSort}
              deleteButtonText="Delete participant"
            />
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PlayerTable;
